"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Introduction() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="153167" id="managing-cookies" className="py-16 md:py-24 lg:py-32 bg-background overflow-hidden relative z-0">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div ref={textRef} className={`flex flex-col items-start space-y-6 transition-all duration-700 ease-out ${textVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="inline-flex items-center rounded-sm border border-border bg-accent/50 px-3 py-1 text-sm font-medium text-secondary-foreground font-sans">
              Privacy Settings
            </div>
            
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground leading-tight font-serif">
              Control & Management
            </h2>
            
            <p className="text-lg text-muted-foreground leading-relaxed max-w-xl font-sans">
              Most web browsers allow you to control cookies through their settings preferences. To adjust your experience, navigate to your browser&apos;s Privacy menu. In Chrome, access Settings &gt; Privacy and security. Safari users should visit Preferences &gt; Privacy, while Firefox users can manage data via Options &gt; Privacy &amp; Security. Please note that disabling essential cookies may impact the functionality and performance of our global logistics platform.
            </p>
            
            <div className="pt-4">
              <Button asChild size="lg" className="group rounded-sm bg-primary text-primary-foreground hover:bg-primary/90">
                <Link to="/PrivacyPolicyPage">
                  Full Privacy Policy
                  <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative transition-all duration-700 delay-200 ease-out translate-x-5 ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            {}
            <div className="absolute -z-10 -bottom-8 -right-8 w-64 h-64 bg-accent/20 rounded-full blur-3xl" />
            <div className="absolute -z-10 -top-8 -left-8 w-48 h-48 bg-primary/5 rounded-full blur-2xl" />
            
            <div className="relative rounded-sm overflow-hidden shadow-xl border border-border/50 bg-card">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576388/img/introduction_professional_team.png" alt="Digital security and cookie management interface" className="w-full h-auto object-cover aspect-[4/3] hover:scale-105 transition-transform duration-700 ease-in-out" />
              {}
              <div className="absolute inset-0 bg-gradient-to-tr from-primary/10 via-transparent to-transparent pointer-events-none mix-blend-overlay" />
            </div>
            
            {}
            <div className="absolute -bottom-6 -left-6 bg-card border border-border shadow-md rounded-sm p-4 flex items-center gap-4 animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-500">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-accent/30 text-primary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-award"><circle cx="12" cy="8" r="6" /><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11" /></svg>
              </div>
              <div>
                <p className="text-sm font-bold text-foreground font-serif">Data Integrity</p>
                <p className="text-xs text-muted-foreground font-sans">Secure Operations</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}